import { render, staticRenderFns } from "./DashboardRewardsTile.vue?vue&type=template&id=65f87ede&scoped=true&lang=pug"
import script from "./DashboardRewardsTile.vue?vue&type=script&lang=ts"
export * from "./DashboardRewardsTile.vue?vue&type=script&lang=ts"
import style0 from "./DashboardRewardsTile.vue?vue&type=style&index=0&id=65f87ede&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f87ede",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
